import { status_filter } from "../../components/constant/constant";
import React, { useState } from "react";
import { toast } from "react-toastify";
import Search from "../../components/form/Search";
import Table from "../../components/elements/table/Table";
import { setTitle } from "../../helpers/MetaTag";
import { handleFilterChange } from "../../helpers";
import DeleteModal from "../../components/common/DeleteModal";

import {
  scholarshipDelete,
  scholarshipList,
  scholershipOrder,
} from "../../services/scholarshipService";
import dayjs from "dayjs";
import useFetch from "../../hooks/useFetch";
import { useDebounce } from "../../hooks/useDebounce";
import LimitSelect from "../../components/elements/LimitSelect";
import useMutation from "../../hooks/useMutation";
import ManageScholarshipTimelineModal from "../../components/sections/admin/scholarshipTimeline/modals/ManageScholarshipTimelineModal";
import useForm from "../../hooks/useForm";
import Input from "../../components/form/Input";
import Button from "../../components/form/Button";
import Textarea from "../../components/form/Textarea";
import Editor from "../../components/form/Editor";
import { useGetPermission } from "../../hooks/useGetPermission";

const ScholarshipTimeline = () => {
  setTitle("Vpeters Admin | Scholarship Timeline");
  const { permission, status } = useGetPermission("timeline");

  const [selectedItems, setSelectedItems] = useState([]);
  const [modalOpen, setModalOpen] = useState({ isOpen: false, data: null });
  const [keyword, setKeyword] = useState("");
  const search = useDebounce(keyword, 300);
  const [deleteModal, setDeleteModal] = useState({
    isOpen: false,
    data: null,
  });
  const [filters, setFilters] = useState({
    limit: 10,
    page: 1,
    sortQuery: "ordering",
  });

  const { data, error, isLoading, updateData, isFetching, refetch } = useFetch({
    dependencies: ["scholarshipTimeline", filters, search, permission?.list],
    fetchFunction: async () => {
      const res = await scholarshipList({
        ...filters,
        ...(search && { keyword: search }),
      });
      if (res?.status !== 200) {
        toast.warning(res?.message);
      }
      return res?.docs;
    },
    enabled: !!permission?.list && status === "ok",
  });

  const tableHeadData = [
    {
      _id: 1,
      name: " Scholarship Title",
      align: "left",
    },

    {
      _id: 2,
      name: "Open Date",
      align: "left",
    },
    {
      _id: 3,
      name: "Close Date",
      align: "left",
    },
    {
      _id: 4,
      name: "Status",
      align: "left",
      filterData: status_filter,
      onFilter: (data) => {
        handleFilterChange(
          "status",
          data?.map((item) => item?.value),
          setFilters
        );
        setFilters((prev) => ({ ...prev, offset: 0, currentPage: 0 }));
      },
    },
    ...(permission?.edit || permission?.delete
      ? [
          {
            _id: 5,
            name: "Action",
            align: "left",
          },
        ]
      : []),
  ];

  // Table Body Data =====================>
  const tableData = data?.data?.map((item) => {
    return {
      _id: item?._id,
      rowData: [
        {
          _id: 1,
          type: "text",
          align: "left",
          cellClass: "!min-w-[100px]",
          data: item?.title || "-",
          isTooltip: false,
        },
        {
          _id: 2,
          type: "text",
          align: "left",
          cellClass: "!min-w-[100px]",
          data: item?.publishDate
            ? dayjs(item?.publishDate).format("DD MMM, YYYY")
            : "-",
        },
        {
          _id: 4,
          type: "text",
          align: "left",
          cellClass: "!min-w-[100px]",
          data: item?.publishEndDate
            ? dayjs(item?.publishEndDate).format("DD MMM, YYYY")
            : "-",
        },
        {
          _id: 9,
          type: "status",
          align: "left",
          cellClass: "!min-w-[100px]",
          statusLabel: item?.status === 1 ? "Published" : "Draft",
          statusType: item?.status === 1 ? "success" : "danger",
        },
        ...(permission?.edit || permission?.delete
          ? [
              {
                _id: 12,
                type: "action",
                align: "left",
                cellClass: "w-[5%]",
                actionData: [
                  ...(permission?.edit && status === "ok"
                    ? [
                        {
                          _id: 1,
                          name: "Edit",
                          icon: "fa-regular fa-pen-to-square",
                          onClick: () => {
                            setModalOpen({ isOpen: true, data: item });
                          },
                          standout: false,
                        },
                      ]
                    : []),
                  ...(permission?.delete && status === "ok"
                    ? [
                        {
                          _id: 2,
                          name: "Delete",
                          icon: "fa-regular fa-trash-can",
                          standout: true,
                          onClick: () => {
                            setDeleteModal({
                              isOpen: true,
                              data: item,
                            });
                          },
                        },
                      ]
                    : []),
                ],
              },
            ]
          : []),
      ],
    };
  });

  function scholarshipAddResponse(res) {
    if (res?.status === 200 || res?.status === 201) {
      if (res?.status === 201) {
        updateData((pre) => ({
          ...pre,
          data: [res?.data, ...(pre?.data || [])],
        }));
      }
      if (res?.status === 200) {
        updateData((pre) => ({
          ...pre,
          data: pre?.data?.map((item) =>
            item?._id === res?.data?._id ? res?.data : item
          ),
        }));
      }
      setModalOpen({ isOpen: false, data: null });
    } else {
      toast.warning(res?.message || res?.error);
    }
  }

  //   scholarship delete handler =================>
  const { mutate: deletefunction, isPending: deletePending } = useMutation({
    mutationFn: async (payload) => {
      const res = await scholarshipDelete({
        ids: Array.isArray(payload) ? payload : [payload],
      });
      return {
        res,
        payload: Array.isArray(payload) ? payload : [payload],
      };
    },
    onSuccess: ({ res, payload }) => {
      if (res?.status === 200) {
        setDeleteModal({ isOpen: false, data: null });
        updateData((pre) => {
          pre.data = (pre?.data || [])?.filter(
            (item) => !payload?.includes(item?._id)
          );
          return { ...pre };
        });
        if (data?.metadata?.totalDocs > filters?.limit) {
          refetch();
        }
      } else {
        toast.warning(res?.message || res?.error);
      }
    },
    onError: (error) => {
      console.log(error);
    },
  });

  //   eligibility ordering handler =================>
  async function scholershipOrdering(newData, oldData) {
    const ordering_data = newData?.map((item, i) => ({
      id: item?._id,
      ordering: i,
    }));
    const res = await scholershipOrder({ ordering_data });
    if (res?.status !== 200) {
      updateData((pre) => {
        pre.data = oldData;
        return { ...pre };
      });
    }
  }

  return (
    <div className="space-y-4 w-full flex flex-col pb-10">
      <div className="space-y-8">
        <div className="font-bold text-center text-lg xl:text-3xl text-chestnut-rose">
          Scholarship Timeline List
        </div>
        <div className="flex items-center gap-3">
          <div className="w-36">
            <LimitSelect
              value={filters?.limit}
              allValue={data?.metadata?.totalDocs}
              onChange={(val) => handleFilterChange("limit", val, setFilters)}
            />
          </div>
          <div className="w-72">
            <Search
              placeholder={"Search here"}
              search={(val) => {
                setKeyword(val);
                handleFilterChange("page", 1, setFilters);
              }}
              iconPosition={"right"}
            />
          </div>
        </div>
      </div>
      {status === "ok" &&
        (permission?.list ? (
          <Table
            tableHeadData={tableHeadData}
            tableData={tableData}
            isLoder={isLoading}
            pageCount={data?.metadata?.totalPages}
            currentPage={filters?.page}
            onPageChange={(val) => {
              handleFilterChange("page", val, setFilters);
              setSelectedItems([]);
            }}
            isFetching={isFetching}
            isOrderingDisabled={false}
            selectedItems={selectedItems}
            setSelectedItems={setSelectedItems}
            tableActionDropdownContainer={"!w-48"}
            handleOrdering={(newData, oldData) => {
              scholershipOrdering(newData, oldData);
            }}
            originalData={[...(data?.data || [])]}
            setOriginalData={(data) =>
              updateData((pre) => {
                pre.data = data;
                return { ...pre };
              })
            }
          />
        ) : (
          <div className="font-semibold text-xl text-center h-60 flex items-center justify-center text-shades-07">
            You don't have permission to view this list.
          </div>
        ))}
      <ManageScholarshipTimelineModal
        open={modalOpen?.isOpen}
        close={() => setModalOpen({ isOpen: false, data: null })}
        getResponse={scholarshipAddResponse}
        data={modalOpen?.data}
      />
      <DeleteModal
        open={deleteModal?.isOpen}
        loading={deletePending}
        onClose={() => setDeleteModal((pre) => ({ ...pre, isOpen: false }))}
        deleteHandler={() => deletefunction([deleteModal?.data?._id])}
      />
    </div>
  );
};

export default ScholarshipTimeline;
